export default "__VITE_ASSET__e8ec7a5b__"